import * as React from 'react'
function SvgTagFilled(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M35.4 20.6l-16-16C19 4.2 18.6 4 18 4H6c-1.2 0-2 .8-2 2v12c0 .6.2 1 .6 1.4l16 16c.4.4.8.6 1.4.6.6 0 1-.2 1.4-.6l12-12c.8-.8.8-2 0-2.8zM12 14c-1.2 0-2-.8-2-2s.8-2 2-2 2 .8 2 2-.8 2-2 2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgTagFilled
